'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;}; // Modules
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _HomePagePropertiesCarousel = require('../../HomePagePropertiesCarousel/HomePagePropertiesCarousel.scss');var styles = _interopRequireWildcard(_HomePagePropertiesCarousel);
var _circle_arrow = require('../../../../static/icons/circle_arrow.svg');var _circle_arrow2 = _interopRequireDefault(_circle_arrow);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getSlidesCount = function getSlidesCount(wrapperWidth, spaceBetween, slideWidth) {return wrapperWidth ?
  wrapperWidth / (slideWidth + spaceBetween) :
  'auto';};

var params = {
  spaceBetween: 15,
  rebuildOnUpdate: true,
  slidesPerView: 3,
  threshold: 20,
  autoHeight: true,
  navigation: {
    nextEl: '.professionals-carousel-button-next',
    prevEl: '.professionals-carousel-button-prev',
    disabledClass: 'disabled-arrow' },

  breakpoints: {
    767: {
      navigation: {
        nextEl: null,
        prevEl: null } } },



  renderCustomPrevButton: function renderCustomPrevButton() {return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(styles.arrowWrapper, styles.prevArrow, 'professionals-carousel-button-prev') },

        _react2.default.createElement('img', { src: _circle_arrow2.default, alt: '' })));},


  renderCustomNextButton: function renderCustomNextButton() {return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(styles.arrowWrapper, styles.nextArrow, 'professionals-carousel-button-next') },

        _react2.default.createElement('img', { src: _circle_arrow2.default, alt: '' })));} };




var CompanySlider = function CompanySlider(props) {
  var additionalParams = props.isMobile ? {
    slidesPerView: getSlidesCount(props.wrapperWidth, 15, 265) } :
  {};

  return (
    _react2.default.createElement(_reactIdSwiper2.default, _extends({},
      params,
      additionalParams),

      props.children));


};

CompanySlider.propTypes = {
  children: _propTypes2.default.array,
  wrapperWidth: _propTypes2.default.number,
  isMobile: _propTypes2.default.bool };exports.default =


CompanySlider;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyGallery/CompanySlider.js
// module id = 2640
// module chunks = 0